import * as React from 'react';
import clsx from 'clsx';

interface AuthGreetingTextProps {
  className?: string;
}

/** Stylized tagline text used in auth page headers. */
export const AuthGreetingText: React.FC<AuthGreetingTextProps> = ({ className }) => (
  <span
    className={clsx(
      'whitespace-nowrap font-grape text-20 font-normal leading-none tracking-normal fold:text-30',
      className
    )}
  >
    your inner circle now includes the greatest
  </span>
);
